import * as actionTypes from '../actions'

const initialState: any = { 
    id: 0,
    products: [],
    totalAmount: 0,
    consumptionTaxAmountTotal: 0,
    taxAmountTotal: 0,
    active: false,
    cartState: false,
    clientId: 0,
    date: false,
    loading: false,
    customShippingValue:0,
    address: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    city: '',
    codeDane: '',
    shipping: [],
    invoice: {},
    discountAmount: 0,
    detailTotal: {},
    shippingCost: 0,
    guide: null,
    guideId: null,
    trackingInternalUrl: null,
    carrier: null,
    stateDelivery: '',
    isAveonline: false,
}

const purchaseCartReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.LOADING_PURCHASE : {
            return {
                ...state,
                loading: true
            }
        }
        case actionTypes.ADD_PURCHASE_PRODUCTS: {
            return {
                ...state,
                id: action.payload.id,
                totalAmount: action.payload.total,
                consumptionTaxAmountTotal: action.payload.consumptionTaxAmountTotal,
                taxAmountTotal: action.payload.taxAmountTotal,
                cartState: action.payload.state,
                date: action.payload.date,
                clientId: action.payload.clientId,
                publicKey: action.payload.publicKey,
                products: action.payload.products,
                address: action.payload.address,
                contactName: action.payload.contactName,
                contactPhone: action.payload.contactPhone,
                contactEmail: action.payload.email,
                city: action.payload.city,
                codeDane: action.payload.codeDane,
                loading: false,
                shipping: action.payload.shipping,
                invoice: action.payload.invoice,
                discountAmount: action.payload.discountAmount,
                detailTotal: action.payload.detailTotal,
                shippingCost: action.payload.shippingCost,
                guide: action.payload.guide,
                guideId: action.payload.guideId,
                trackingInternalUrl: action.payload.trackingInternalUrl,
                carrier: action.payload.carrier,
                stateDelivery: action.payload.stateDelivery,
                isAveonline: action.payload.isAveonline,
            }
        }
        default: {
            return state
            
        }
    }
}

export default purchaseCartReducer
